(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(c) { return 'R ' + (c / 100).toFixed(2); }

  function toast(html) {
    var old = document.querySelector('.tt-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'tt-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = html;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4500);
  }

  function bundleMsg(n) {
    if (n >= 6) return '<strong>15% off unlocked</strong>Max bundle saving applied';
    if (n >= 4) { var a = 6 - n; return '<strong>10% off unlocked</strong>Add ' + a + ' more pack' + (a > 1 ? 's' : '') + ' for 15% off'; }
    if (n >= 2) { var b = 4 - n; return '<strong>5% off unlocked</strong>Add ' + b + ' more pack' + (b > 1 ? 's' : '') + ' for 10% off'; }
    if (n === 1) return '<strong>Add 1 more pack</strong>to check out and save 5%';
    return '<strong>Bundle &amp; save</strong>Mix any colours · minimum 2 packs';
  }

  function renderBundle(n) {
    document.querySelectorAll('[data-tt-bundle]').forEach(function (el) {
      el.setAttribute('data-count', n);
      var m = el.querySelector('[data-tt-bb-msg]'); if (m) m.innerHTML = bundleMsg(n);
      var f = el.querySelector('[data-tt-bb-fill]'); if (f) f.style.width = Math.min(100, Math.round(n * 100 / 6)) + '%';
      var tr = el.querySelector('[role="progressbar"]'); if (tr) tr.setAttribute('aria-valuenow', Math.min(n, 6));
      el.querySelectorAll('[data-tt-step]').forEach(function (s) { s.classList.toggle('is-hit', n >= Number(s.getAttribute('data-tt-step'))); });
    });
    document.documentElement.setAttribute('data-tt-count', n);
  }

  var busy = false;
  function refreshCount() {
    busy = true;
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        document.querySelectorAll('[data-tt-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderBundle(cart.item_count);
        return cart;
      }).catch(function () { busy = false; });
  }

  if (window.fetch && !window.__ttFetch) {
    window.__ttFetch = true;
    var nf = window.fetch;
    window.fetch = function (input) {
      var p = nf.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (!busy && /\/cart\/(add|change|update|clear)/.test(u)) { p.then(function () { setTimeout(refreshCount, 150); }); }
      } catch (e) {}
      return p;
    };
  }

  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    }).then(refreshCount);
  }

  // Minimum order: block checkout when the cart holds a single pack
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!c) return;
    var n = Number(document.documentElement.getAttribute('data-tt-count') || '0');
    if (n > 0 && n < 2) { e.preventDefault(); e.stopPropagation(); toast('Minimum order is 2 packs. Add 1 more pack (any colour) to check out.'); }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tt-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    addToCart(btn.getAttribute('data-tt-quick-add'), btn.getAttribute('data-tt-qty') || 1).then(function (cart) {
      btn.textContent = 'ADDED ✓';
      btn.classList.add('is-added');
      toast(bundleMsg(cart.item_count) + ' <a href="' + root + 'cart">View cart →</a>');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
    }).catch(function (err) { btn.disabled = false; toast(err.message); });
  });

  document.querySelectorAll('[data-tt-tabs]').forEach(function (wrap) {
    var scope = document.querySelector(wrap.getAttribute('data-tt-tabs'));
    if (!scope) return;
    wrap.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tt-filter]');
      if (!tab) return;
      var f = tab.getAttribute('data-tt-filter');
      wrap.querySelectorAll('[data-tt-filter]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      scope.querySelectorAll('[data-tt-cat]').forEach(function (card) {
        var cat = card.getAttribute('data-tt-cat');
        card.hidden = f === 'all' ? cat === 'fillers' : cat !== f;
      });
    });
  });

  document.querySelectorAll('[data-tt-pdp]').forEach(function (form) {
    var qty = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[data-tt-add]');
    var price = Number(form.getAttribute('data-tt-price')) || 0;
    function update() {
      var picked = form.querySelector('[name="tt-pack"]:checked');
      var n = picked ? Number(picked.value) : 2;
      qty.value = n;
      form.querySelectorAll('.tt-pack').forEach(function (row) {
        var r = row.querySelector('input');
        var k = Number(r.value), off = Number(r.getAttribute('data-off')) || 0;
        var full = price * k, total = Math.round(full * (100 - off) / 100);
        var t = row.querySelector('[data-tt-total]'), f = row.querySelector('[data-tt-full]'), each = row.querySelector('[data-tt-each]'), sv = row.querySelector('[data-tt-saved]');
        if (t) t.textContent = money(total);
        if (f) f.textContent = money(full);
        if (each) each.textContent = money(Math.round(total / k));
        if (sv) sv.textContent = money(full - total);
      });
      if (btn && !btn.disabled) {
        var off = picked ? Number(picked.getAttribute('data-off')) || 0 : 5;
        btn.textContent = 'ADD ' + n + ' PACK' + (n > 1 ? 'S' : '') + ' · ' + money(Math.round(price * n * (100 - off) / 100));
      }
    }
    form.querySelectorAll('[name="tt-pack"]').forEach(function (r) { r.addEventListener('change', update); });
    form.querySelectorAll('[name="id"][type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () { price = Number(r.getAttribute('data-price')) || price; update(); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      btn.disabled = true;
      addToCart(idEl.value, qty.value).then(function (cart) {
        btn.disabled = false;
        btn.textContent = 'ADDED TO CART ✓';
        toast(bundleMsg(cart.item_count) + ' <a href="' + root + 'cart">View cart →</a>');
        setTimeout(update, 2200);
      }).catch(function (err) { btn.disabled = false; update(); toast(err.message); });
    });
    update();
  });

  document.querySelectorAll('[data-tt-loc-search]').forEach(function (input) {
    var list = document.querySelector(input.getAttribute('data-tt-loc-search'));
    var empty = document.querySelector('[data-tt-loc-empty]');
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      list.querySelectorAll('.tt-loc').forEach(function (el) {
        var hit = !q || el.textContent.toLowerCase().indexOf(q) > -1;
        el.hidden = !hit;
        if (hit) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    });
  });

  var start = document.querySelector('[data-tt-bundle]');
  if (start) document.documentElement.setAttribute('data-tt-count', start.getAttribute('data-count') || '0');
})();